<a
  class="round-button round-button--{{ size }} {{ theme }}"
  href="#"
  [class.active]="isActive"
  [ngClass]="{ 'round-button--disabled': disabled }"
  [routerLink]="link ? [link] : null"
  [queryParams]="link ? params : null"
  (click)="action.observers.length ? emitAction($event) : undefined"
>
  <span class="round-button-icon">
    <icon
      [set]="set"
      [name]="icon"
      [rotate]="rotate"
      [size]="iconSize"
    />
  </span>
</a>
